import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'What does Bluecore offer?',
  answer: 'Bluecore provides a subscription-based digital library service. We offer access to a curated collection of ebooks across various genres, accessible via our cloud-based platform on any device.'
}, {
  question: 'How do subscriptions work?',
  answer: "Our subscriptions are billed annually. Once you subscribe to a plan (Silver, Gold, or Platinum), you gain immediate access to the library up to your plan's limit. You can read as much as you like within your plan's allowance."
}, {
  question: 'How many books can I access?',
  answer: 'Access limits depend on your chosen plan: Silver allows up to 200 ebooks, Gold allows up to 700 ebooks, and Platinum provides unlimited access to our entire catalogue.'
}, {
  question: 'What is the billing cycle?',
  answer: 'All Bluecore plans are billed on an annual basis. Your subscription will automatically renew each year unless cancelled prior to the renewal date.'
}, {
  question: 'How do I upgrade my plan?',
  answer: 'You can upgrade your plan at any time through your account dashboard. The price difference will be calculated on a pro-rata basis for the remainder of your billing year.'
}, {
  question: 'How do I contact support?',
  answer: 'Our support team is available via email at manishhoran123@gmail.com. We aim to respond to all enquiries within one working day.'
}, {
  question: 'How is my data handled?',
  answer: 'We take data security seriously. All personal information and payment details are encrypted and processed securely. We do not share your reading habits or personal data with third parties.'
}, {
  question: 'What is the cancellation policy?',
  answer: 'You may cancel your subscription at any time. Your access will continue until the end of your current billing period. We do not offer partial refunds for unused time.'
}, {
  question: 'Are there any technical requirements?',
  answer: 'Bluecore is a cloud-based platform accessible via any modern web browser (Chrome, Safari, Firefox, Edge) on desktop, tablet, or mobile devices. A stable internet connection is required for browsing, though offline reading is available via our app.'
}];
export function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <main className="flex-1 bg-background" data-id="element-215">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-216">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-217">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-218">
            Frequently Asked Questions
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-219">
            Find answers to common questions about Bluecore's service, billing,
            and features.
          </motion.p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-20 bg-white" data-id="element-220">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
          <div className="space-y-4" data-id="element-222">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.4
          }} className="border border-slate-200 rounded-lg overflow-hidden" data-id="element-223">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-slate-50 transition-colors" data-id="element-224">
                  <span className="font-semibold text-slate-dark pr-8" data-id="element-225">
                    {faq.question}
                  </span>
                  {openIndex === index ? <Minus className="w-5 h-5 text-accent flex-shrink-0" data-id="element-226" /> : <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-227" />}
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0
            }} className="overflow-hidden bg-slate-50" data-id="element-228">
                  <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-100 mt-4" data-id="element-229">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
}